import { IndicatorType } from '../constants/common'
import Indicator from './indicator'

class None extends Indicator {
  static type = IndicatorType.None
  static label = 'None'

  compute() {}

  renderIndicator() {}

  toString() {
    return ''
  }
}

export default None
